import { render } from "./Settings.vue?vue&type=template&id=a5e9cb36"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=a5e9cb36&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__